<template>
  <div >
    <title-bar :title-stack="['Sound Shuttle']" />
    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-one-third">
          <div class="box">
            <hplot style="height:35em;" yLabel='Frequency [Hz]' v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" :traces="['7c87ceff0960/sound_s1_avg']" traceNames="['test']"></hplot>
            <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Temperature and Humidity" yLabel='Temperature [°C], Humidity [RH]' :traces="['7c87ceff0960/temphumi_x', '7c87ceff0960/temphumi_y']" :traceNames="['temp', 'humidity']"></plot>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="box">
            <Map v-bind:timeCursor="timeCursor" device="c45bbe300c5c" :timeRange="timeRange"></Map>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="box">
            <hplot style="height:35em;" yLabel='Frequency [Hz]' v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" :traces="['7c87ceff0944/sound_s1_avg']" traceNames="['test']"></hplot>
            <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Temperature and Humidity" yLabel='Temperature [°C], Humidity [RH]' :traces="['7c87ceff0944/temphumi_x', '7c87ceff0944/temphumi_y']" :traceNames="['temp', 'humidity']"></plot>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import hplot from '@/components/TN-HPlot.vue'
import Map from '@/components/TN-Map'
import TitleBar from '@/components/TitleBar'
import Plot from '@/components/TN-Plot'

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

export default {
  name: 'Sound.vue',
  components: {
    hplot,
    TitleBar,
    Map,
    Plot
  },
  data () {
    return {
      id: null,
      timeRange: [yesterday(), new Date()],
      timeCursor: 0
    }
  },
  methods: {
    updateRange: function (val) {
      // console.log('updated range from event', val)
      this.timeRange = val
    },
    updateCursor: function (val) {
      this.timeCursor = val
    }
  }
}
</script>

<style scoped>

</style>
